var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"base-switch",class:{
    'base-switch--on': _vm.value,
    'base-switch--disabled': _vm.disabled,
  },attrs:{"type":"button","role":"switch","aria-checked":_vm.value ? 'true' : 'false',"aria-label":_vm.ariaLabel,"disabled":_vm.disabled,"data-testid":_vm.dataTestid},on:{"click":_vm.onToggle}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"base-switch__track",attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"base-switch__thumb"})])
}]

export { render, staticRenderFns }